// eMemo section of the profile page: each person keys in their own eMemo login once.
// It is checked with eMemo, stored encrypted and never shown again. When forms are
// submitted, people pick whose saved login to use (see EmemoPicker).
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../config/api';

const fmt = (v) => {
  if (!v) return '—';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString('th-TH', { day: 'numeric', month: 'short', year: '2-digit', hour: '2-digit', minute: '2-digit' });
};

const EmemoLogin = () => {
  const [status, setStatus] = useState(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/ememo/me`)
      .then(resp => { setStatus(resp.data); setUsername(resp.data.username || ''); })
      .catch(() => setError('โหลดการตั้งค่าไม่สำเร็จ'));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const resp = await axios.put(`${API_URL}/ememo/me`, { username: username.trim(), password });
      setStatus(resp.data);
      setPassword('');
      toast.success('บันทึกบัญชี eMemo เรียบร้อยแล้ว');
    } catch (err) {
      setError(err.response?.data?.message || 'บันทึกไม่สำเร็จ');
    } finally {
      setSaving(false);
    }
  };

  const remove = async () => {
    if (!window.confirm('ลบบัญชี eMemo ที่บันทึกไว้?')) return;
    try {
      const resp = await axios.delete(`${API_URL}/ememo/me`);
      setStatus(resp.data);
      setUsername('');
      setPassword('');
      toast.success('ลบบัญชี eMemo แล้ว');
    } catch (err) {
      toast.error(err.response?.data?.message || 'ลบไม่สำเร็จ');
    }
  };

  return (
    <section className="rs-card" aria-label="บัญชี eMemo">
      <div className="rs-card__head">
        <div className="rs-card__headtext">
          <div className="rs-card__kicker">03 / EMEMO</div>
          <h2 className="rs-card__title">บัญชี eMemo</h2>
          <p className="rs-card__desc">กรอกอีเมลและรหัสผ่าน eMemo ของคุณครั้งเดียว เพื่อให้ระบบใช้ส่งเอกสารขออนุมัติได้</p>
        </div>
      </div>

      {status?.configured && (
        <div className="wlog__pill wlog__pill--ok" style={{ marginBottom: 14 }}>
          <i className="bi bi-check-circle-fill"></i> บันทึกแล้ว · {status.username} · ตรวจสอบล่าสุด {fmt(status.verified_at)}
        </div>
      )}
      {error && <div className="econ-alert" role="alert"><div className="econ-alert__line">{error}</div></div>}

      <form onSubmit={save} autoComplete="off" style={{ maxWidth: 460 }}>
        <label htmlFor="ememo_user">อีเมล / ชื่อผู้ใช้ eMemo</label>
        <input id="ememo_user" className="rs-input" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="off" />
        <label htmlFor="ememo_pass" style={{ marginTop: 12, display: 'block' }}>รหัสผ่าน eMemo</label>
        <input id="ememo_pass" className="rs-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password"
          placeholder={status?.configured ? 'กรอกใหม่เพื่อเปลี่ยนรหัสผ่าน' : ''} />
        <div style={{ display: 'flex', gap: 10, marginTop: 16, flexWrap: 'wrap' }}>
          <button type="submit" className="rs-btn rs-btn--primary" disabled={saving || !username.trim() || !password}>
            {saving ? 'กำลังตรวจสอบ...' : 'ตรวจสอบและบันทึก'}
          </button>
          {status?.configured && <button type="button" className="rs-btn rs-btn--ghost" onClick={remove}>ลบบัญชีที่บันทึกไว้</button>}
        </div>
        <p className="rs-help" style={{ marginTop: 12 }}>
          ระบบตรวจสอบรหัสผ่านกับ eMemo ก่อนบันทึก และเก็บแบบเข้ารหัส ไม่แสดงรหัสผ่านซ้ำ ถ้ารหัสผ่าน eMemo ของคุณมีการเปลี่ยน ให้มากรอกใหม่ที่นี่
        </p>
      </form>
    </section>
  );
};

export default EmemoLogin;
